import { render, staticRenderFns } from "./yotpo-reviews.vue?vue&type=template&id=e16ed7da"
import script from "./yotpo-reviews.vue?vue&type=script&lang=js"
export * from "./yotpo-reviews.vue?vue&type=script&lang=js"
import style0 from "./yotpo-reviews.vue?vue&type=style&index=0&id=e16ed7da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports